/**
 * Constants for AI Operator Feedback feature
 */
export const FEEDBACK_CONSTANTS = {
  MAX_MESSAGE_LENGTH: 1000,
  DIMENSIONS: {
    BUTTON_SIZE: '32px',
    ICON_SIZE: '12px',
    BORDER_RADIUS: '10px',
    MIN_HEIGHT: '48px',
  },
  COLORS: {
    POSITIVE_BG: '#EEFCF3',
    POSITIVE_TEXT: '#1E9847',
    POSITIVE_SUCCESS_TEXT: '#21783F',
    NEGATIVE_BG: '#FEF0F0',
    NEGATIVE_TEXT: '#D52026',
    CONTAINER_BG: '#ECF3FF',
    SUCCESS_BG: '#EEFCF3',
    BORDER: '#D9D9D9',
    WHITE: 'white',
    GRAY_500: 'gray.500',
    GRAY_600: 'gray.600',
  },
  MESSAGES: {
    THANK_YOU: 'Thank you for your feedback!',
    POSITIVE_SUCCESS: 'Feedback submitted. Thank you for your input!',
    NEGATIVE_SUCCESS: "Feedback submitted. We'll work on improving this!",
    SPECIFY_TEXT: 'Please specify:',
    SUBMIT_BUTTON: 'Submit',
    LOADING_TEXT: 'Submitting...',
    HEADER_RESOLVED: 'Resolved By the AI Operator',
    HEADER_FLAGGED: 'Flagged By the AI Operator',
    SUBHEADER_RESOLVED: 'Was the incident resolved accurately?',
    SUBHEADER_FLAGGED: 'Was the incident flagged accurately?',
    PLACEHOLDER_POSITIVE: 'What went well...',
    PLACEHOLDER_NEGATIVE: 'What can be improved...',
    ERROR_TITLE: 'Error submitting feedback',
    ERROR_DESCRIPTION: 'Please try again later.',
  },
  ARIA_LABELS: {
    POSITIVE_BUTTON: 'Mark feedback as positive',
    NEGATIVE_BUTTON: 'Mark feedback as negative',
    FEEDBACK_TEXTAREA: 'Enter your feedback details',
    SUBMIT_BUTTON: 'Submit feedback',
    AI_OPERATOR_ICON: 'AI Operator',
    FEEDBACK_FORM: 'AI Operator Feedback Form',
  },
}
